var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27 0L0 5.27V12.73L5.27 18H12.73L18 12.73V5.27L12.73 0H5.27ZM5.41 4L9 7.59L12.59 4L14 5.41L10.41 9L14 12.59L12.59 14L9 10.41L5.41 14L4 12.59L7.59 9L4 5.41",
    fill: "#95A1B9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/CancelIcon.7d654acd5c4e27c91d1182ca0eda93b0.svg";
export { ForwardRef as ReactComponent };